(() => {
  'use strict';
  const key = 'torque-alliance-wishlist';
  const config = document.getElementById('ta-wishlist-config');
  if (!config) return;
  const strings = JSON.parse(config.textContent);
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(h => typeof h === 'string' && h.length <= 255 && /^[a-z0-9][a-z0-9_-]*$/i.test(h)))].slice(0, 100) : [];
    } catch { return []; }
  };
  let items = read();
  const notify = message => {
    const status = document.getElementById('ta-wishlist-status');
    if (status) { status.textContent = message; status.hidden = !message; }
  };
  const publish = () => document.dispatchEvent(new Event('ta:wishlist-change'));
  const save = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { notify(strings.storage_error); return false; }
    items = next;
    notify('');
    publish();
    return true;
  };
  window.taWishlist = { read: () => [...items], remove: handle => save(read().filter(h => h !== handle)) };
  customElements.define('ta-wishlist-button', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.update = () => {
        const saved = items.includes(this.button.dataset.handle);
        this.button.setAttribute('aria-pressed', String(saved));
        this.button.querySelector('span').textContent = saved ? this.button.dataset.remove : this.button.dataset.add;
      };
      this.click = () => {
        const current = read(), handle = this.button.dataset.handle;
        if (current.includes(handle)) save(current.filter(h => h !== handle));
        else if (current.length >= 100) notify(strings.limit);
        else save([...current, handle]);
      };
      this.button.addEventListener('click', this.click);
      document.addEventListener('ta:wishlist-change', this.update);
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.click);
      document.removeEventListener('ta:wishlist-change', this.update);
    }
  });
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) { items = read(); publish(); }
  });
  window.addEventListener('pageshow', () => {
    const current = read();
    if (JSON.stringify(current) !== JSON.stringify(items)) { items = current; publish(); }
  });
})();
